import { ApiResponse } from 'common/domain/entities/api-response';
import http from './http';
import { TwoFactorAuthApi } from './two-factor-api';
import { EnableTwoFactorAuthRes } from '../dto/two-factor-backoffice-model';
import axios, { AxiosError } from 'axios';

export default class TwoFactorAuthApiImpl implements TwoFactorAuthApi {
	apiService = http;

	async enableTwoFactorAuth(userId: number): Promise<ApiResponse<EnableTwoFactorAuthRes>> {
		try {
			const resp = await this.apiService.patch('/users/enable-two-factor', { userId: userId.toString() });
			const data = resp.data as ApiResponse<EnableTwoFactorAuthRes>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}

	async confirmTwoFactorAuth(userId: number, code: string): Promise<ApiResponse<boolean>> {
		try {
			const resp = await this.apiService.patch('/users/confirm-two-factor', { userId: userId.toString(), code });
			const data = resp.data as ApiResponse<boolean>;
			return Promise.resolve(data);
		} catch (err) {
			if (axios.isAxiosError(err)) {
				const errData = err as AxiosError;
				if (errData.response?.data) {
					const data = errData.response?.data as ApiResponse<void>;
					return Promise.reject(data);
				}
			}
			const error = { message: 'unexpected_error' } as ApiResponse<void>;
			return Promise.reject(error);
		}
	}
}
